import { TextUtil } from '@suntex.core/animation';

const INFO_PANE_Y_OFFSET = -300;
const HEADER_FONT_SIZE = 14;

export class InfoPane extends createjs.Container {
  constructor(
    content: { header?: string; body?: string },
    opts: { fontFamily: string },
  ) {
    super();
    if (content.header) {
      const headerText = TextUtil.createText(content.header, {
        font: { family: opts.fontFamily, size: HEADER_FONT_SIZE },
        color: '#666',
        textAlign: 'right',
        textBaseline: 'top',
      });
      headerText.x = 300;
      headerText.y = -300;
      this.addChild(headerText);
    }

    if (content.body) {
      const bodyText = TextUtil.createText(content.body, {
        font: { family: opts.fontFamily, size: 12 },
        color: '#999',
        textAlign: 'right',
        textBaseline: 'top',
      });
      bodyText.x = 300;
      bodyText.y = INFO_PANE_Y_OFFSET + HEADER_FONT_SIZE + 2;
      this.addChild(bodyText);
    }
  }
}
